import React from 'react';

/**
 * La marca de l'aplicació: quatre hipòtesis, tres ratllades i una que aguanta.
 *
 * És la tècnica en un gest. L'ACH **no busca la hipòtesi que es confirma, elimina
 * les que no**, i la que queda dreta és la que ha sobreviscut a la prova — no la
 * que ha guanyat cap concurs.
 *
 * D'aquí surt la regla de color, que és el contrari del que se sol fer: **el
 * color marca el que s'ha refutat, no el que guanya.** A l'aplicació totes les
 * puntuacions són negatives i la millor hipòtesi és la menys marcada; i la
 * pantalla de l'alumne, per decisió presa (vegeu CLAUDE.md §La pantalla de
 * l'examen), no assenyala quina és la bona. Una marca que pintés el guanyador
 * contradiria l'exercici que la pantalla vol provocar.
 *
 * Dues coses que la fan servible a totes dues mides:
 *
 * - **És SVG en línia, no un fitxer.** La CSP de l'aplicació no deixa carregar
 *   res de fora, i així la marca hereta el color del text: al gris pissarra de
 *   la barra d'avui, i en blanc el dia que hi hagi una barra fosca, sense tocar
 *   res.
 * - **Els colors són a `App.css`**, com tota la resta. Aquí no n'hi ha cap
 *   escrit: només classes. El to del ratllat és `--rating-ii`, el mateix «molt
 *   inconsistent» de les cel·les de la matriu, de manera que si algun dia es
 *   canvia l'escala, la marca la segueix sola.
 *
 * Va sempre acompanyada del nom «Anàlisi ACH», i per això és decorativa per a
 * qui fa servir un lector de pantalla: anunciar-la seria repetir el nom que ja
 * es llegeix al costat.
 */
function MarcaACH({ mida = 24, className = '' }) {
  return (
    <svg
      className={`marca-ach ${className}`.trim()}
      width={mida}
      height={mida}
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
    >
      {/* Les tres refutades: hi són, però ja no compten. */}
      <g className="marca-ach__refutades">
        <rect x="1.5" y="3" width="3" height="18" rx="1.5" />
        <rect x="7" y="3" width="3" height="18" rx="1.5" />
        <rect x="12.5" y="3" width="3" height="18" rx="1.5" />
      </g>
      {/* La que aguanta, una mica més ampla: a 20 px la diferència de gruix es
          nota abans que la de to. */}
      <rect className="marca-ach__viva" x="19" y="3" width="3.5" height="18" rx="1.75" />
      {/* La ratlla acaba entre la tercera i la quarta, no al final: ha de quedar
          clar que en creua tres i que la quarta se n'ha escapat. */}
      <path className="marca-ach__ratlla" d="M0.75 18.5 L16.75 5.5" />
    </svg>
  );
}

export default MarcaACH;
